import {
  CREATE_DATE_PLACEHOLDER,
  LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID,
  ASSIGN_IMAGE_TO_PLACEHOLDER } from './../../action-types/entities/datePlaceholders';

export const createDatePlaceholders = datePlaceholder => ({
  type: CREATE_DATE_PLACEHOLDER,
  datePlaceholder,
});

export const loadDatePlaceholderByBookId = bookState => ({
  type: LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID,
  bookState,
});


export const assignImageToPlaceholder = (placeholderId, dateImage) => ({
  type: ASSIGN_IMAGE_TO_PLACEHOLDER,
  placeholderId,
  dateImage,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/datePlaceholders.js